import React, { Component } from 'react'
import { Box } from '@mui/material'
import { MessageCircle01, RefreshCw01, Heart, Share07, Eye } from '@untitledui/icons'
import profilePic from '../images/new-headshot.jpg'
import portfolio from '../portfolio.json'
import Tweet from './Tweet'

export default class TweetLayout extends Component {
	constructor(props) {
		super(props)
	
		this.state = {
			whatToRender: '',
		}
	}
	componentDidMount = () => {
		if(window.location.pathname === '/projects'){
			this.setState({whatToRender: <Tweet resume={this.props.resume} pic={this.props.pic} whatToRender={this.state.whatToRender}/>})
		}else if(window.location.pathname === '/skills'){
			this.setState({whatToRender: <Tweet skills={this.props.portfolio.skills} />})
		}else if(window.location.pathname === '/experience'){
			this.setState({whatToRender: <Tweet experience={this.props.experience}/>})}
	}
	render() {
		const {name, twitter_name} = portfolio.basic_info
		return (
			<Box sx={tweetContainerStyles}>
				<Box sx={tweetStyles}>
					<Box sx={tweetAvatarWrapperStyles}>
						<Box component="img" sx={tweetProfileStyles} alt='profilepic' src={profilePic} />
					</Box>
					<Box sx={tweetMainStyles}>
					{window.location.pathname === '/skills' && (
						<Box component="p" sx={pinnedTweetStyles}>
							<Box component="span" sx={pinnedIconStyles}>
								<i className={portfolio.skills.pinned_tweet[1]}></i>
							</Box>
							{portfolio.skills.pinned_tweet[0]}
						</Box>
					)}
						<Box sx={tweetHeaderStyles}>
							<Box sx={tweetInfoStyles}>
								<Box component="span" sx={tweetNameStyles}>{name}</Box>
								<Box component="span" sx={tweetHandleStyles}>{twitter_name}</Box>
								<Box component="span" sx={tweetTimeStyles}>·</Box>
								<Box component="span" sx={tweetTimeStyles}>now</Box>
							</Box>
						</Box>
						{/*this is what i want to be customizable with Tweet component */}
						{this.state.whatToRender}

					<Box sx={tweetActionsStyles}>
						<Box sx={tweetActionItemStyles}>
							<MessageCircle01 sx={tweetIconStyles} />
						</Box>
					<Box sx={tweetActionItemStyles}>
						<RefreshCw01 sx={tweetIconStyles} />
					</Box>
						<Box sx={tweetActionItemStyles}>
							<Heart sx={tweetIconStyles} />
						</Box>
						<Box sx={tweetActionItemStyles}>
							<Share07 sx={tweetIconStyles} />
						</Box>
						<Box sx={tweetActionItemStyles}>
							<Eye sx={tweetIconStyles} />
						</Box>
					</Box>
					</Box>
				</Box>
			</Box>
		)
	}
}

const tweetContainerStyles = {
	padding: 0,
	'@media (max-width: 768px)': {
		padding: '0 10px',
	},
};

const tweetStyles = {
	display: 'flex',
	gap: '12px',
	padding: '12px 16px',
	transition: 'background-color 0.2s',
	borderBottom: '1px solid #e1e8ed',
	cursor: 'pointer',
	'&:hover': {
		backgroundColor: '#f7f9fa',
	},
};

const tweetAvatarWrapperStyles = {
	flexShrink: 0,
};

const tweetProfileStyles = {
	width: '40px',
	height: '40px',
	borderRadius: '50%',
	objectFit: 'cover',
	flexShrink: 0,
	'@media (max-width: 768px)': {
		width: '35px',
		height: '35px',
	},
};

const tweetMainStyles = {
	display: 'flex',
	flexDirection: 'column',
	flex: 1,
	minWidth: 0,
	paddingBottom: 0,
};

const pinnedTweetStyles = {
	fontSize: '13px',
	color: '#536471',
	marginBottom: '8px',
	display: 'flex',
	alignItems: 'center',
	gap: '4px',
	fontWeight: 400,
	lineHeight: '16px',
	margin: 0,
};

const pinnedIconStyles = {
	display: 'flex',
	alignItems: 'center',
	'& i': {
		color: '#536471',
		fontSize: '13px',
	},
};

const tweetHeaderStyles = {
	marginBottom: '2px',
};

const tweetInfoStyles = {
	display: 'flex',
	alignItems: 'center',
	gap: '4px',
	flexWrap: 'wrap',
	marginBottom: '2px',
};

const tweetNameStyles = {
	fontSize: '15px',
	fontWeight: 700,
	color: '#0f1419',
	margin: 0,
	lineHeight: '20px',
};

const tweetHandleStyles = {
	fontSize: '15px',
	fontWeight: 400,
	color: '#536471',
	margin: 0,
	lineHeight: '20px',
};

const tweetTimeStyles = {
	fontSize: '15px',
	fontWeight: 400,
	color: '#536471',
	margin: 0,
	lineHeight: '20px',
};

const tweetActionsStyles = {
	display: 'flex',
	justifyContent: 'space-between',
	maxWidth: '425px',
	marginTop: '12px',
	paddingTop: 0,
};

const tweetActionItemStyles = {
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	minWidth: '34.75px',
	minHeight: '34.75px',
	marginLeft: '-8px',
	padding: '8px',
	borderRadius: '9999px',
	transition: 'all 0.2s',
	cursor: 'pointer',
	'&:hover': {
		backgroundColor: 'rgba(29, 155, 240, 0.1)',
	},
	'&:first-of-type:hover': {
		backgroundColor: 'rgba(29, 155, 240, 0.1)',
		'& svg': {
			color: '#1d9bf0',
		},
	},
	'&:nth-of-type(2):hover': {
		backgroundColor: 'rgba(0, 186, 124, 0.1)',
		'& svg': {
			color: '#00ba7c',
		},
	},
	'&:nth-of-type(3):hover': {
		backgroundColor: 'rgba(249, 24, 128, 0.1)',
		'& svg': {
			color: '#f91880',
		},
	},
	'&:nth-of-type(4):hover': {
		backgroundColor: 'rgba(29, 155, 240, 0.1)',
		'& svg': {
			color: '#1d9bf0',
		},
	},
	'&:nth-of-type(5):hover': {
		backgroundColor: 'rgba(29, 155, 240, 0.1)',
		'& svg': {
			color: '#1d9bf0',
		},
	},
};

const tweetIconStyles = {
	width: '18.75px',
	height: '18.75px',
	color: '#536471',
	transition: 'all 0.2s',
};
